module.exports = __webpack_public_path__ + "static/anirudh-7740d589d3c03026bd7a7068dbbb6b2b.jpeg";